<template>
  <div
    class="mask"
    :class="!show ? '' : 'mask-show'"
    :style="{ backgroundColor: show ? maskBg : 'rgba(0,0,0,0)' }"
    @click="tapMask"
  >
    <div
      class="popups"
      :class="[theme, direction, triangle ? placement : '']"
      :style="{ top: `${popupsTop}px`, left: `${popupsLeft}px` }"
    >
      <div
        v-for="(item, index) in popData"
        :key="index"
        class="itemChild view"
        :class="{ disabledColor: item.disabled }"
        @click.stop="tapItem(item)"
      >
        <img v-if="item.icon" class="image" :src="item.icon" />
        {{ item.title }}
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maskBg: {
      type: String,
      default: 'rgba(0,0,0,0)'
    },
    placement: {
      type: String,
      default: 'top' // top right bottom left
    },
    direction: {
      type: String,
      default: 'column' //column row
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    popData: {
      type: Array,
      default: () => []
    },
    theme: {
      type: String,
      default: 'light' //light dark
    },
    dynamic: {
      type: Boolean,
      default: false
    },
    gap: {
      type: Number,
      default: 20
    },
    triangle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      popupsTop: '0rem',
      popupsLeft: '0rem',
      show: false
    }
  },
  mounted() {
    // this.popupsPosition()
  },
  methods: {
    async popupsPosition() {
      const getBoundingClient = select => {
        // 获取当前元素信息（大小，位置）
        return new Promise((resolve, reject) => {
          const doms = document.querySelector(select)
          const rect = doms.getBoundingClientRect()
          resolve(rect)
        })
      }
      const clientRect = await getBoundingClient('.popups')
      const hash = {
        top: () => {
          this.popupsTop = this.y - clientRect.height
          this.popupsLeft = this.x - clientRect.width / 2
        },
        right: () => {
          this.popupsTop = this.y - clientRect.height / 2
          this.popupsLeft = this.x
        },
        bottom: () => {
          this.popupsTop = this.y
          this.popupsLeft = this.x - clientRect.width / 2
        },
        left: () => {
          this.popupsTop = this.y - clientRect.height / 2
          this.popupsLeft = this.x
        }
      }
      typeof hash[this.placement] === 'function' && hash[this.placement]()
    },
    tapMask() {
      this.$emit('update:modelValue', !this.modelValue)
    },
    tapItem(item) {
      if (item.disabled) return
      this.$emit('tapPopup', item)
      this.$emit('update:modelValue', !this.modelValue)
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler: async function (newVal, oldVal) {
        if (newVal) await this.popupsPosition()
        this.show = newVal
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  transition: 'background' 0.3s ease-in-out;
  visibility: hidden;

  &.mask-show {
    visibility: visible;
  }
}
.popups {
  position: absolute;
  padding: 0.213333rem;
  border-radius: 0.106667rem;
  display: flex;
  flex-wrap: wrap;
  max-width: 8.533333rem;
  .view {
    padding: 0.213333rem;
  }
  .image {
    display: inline-block;
    vertical-align: middle;
    width: 0.853333rem;
    height: 0.853333rem;
    margin-right: 0.426667rem;
  }
}
.dark {
  background-color: #4c4c4c;
  color: #fff;
  .top-start:after {
    content: '';
    position: absolute;
    top: -0.384rem;
    left: 0.213333rem;
    border-width: 0 0.426667rem 0.426667rem;
    border-style: solid;
    border-color: transparent transparent #4c4c4c;
  }
  .top-end:after {
    content: '';
    position: absolute;
    top: -0.384rem;
    right: 0.213333rem;
    border-width: 0 0.426667rem 0.426667rem;
    border-style: solid;
    border-color: transparent transparent #4c4c4c;
  }
  .bottom-start:after {
    content: '';
    position: absolute;
    bottom: -0.384rem;
    left: 0.213333rem;
    border-width: 0.426667rem 0.426667rem 0;
    border-style: solid;
    border-color: #4c4c4c transparent transparent;
  }
  .bottom-end:after {
    content: '';
    position: absolute;
    bottom: -0.384rem;
    right: 0.213333rem;
    border-width: 0.426667rem 0.426667rem 0;
    border-style: solid;
    border-color: #4c4c4c transparent transparent;
  }
  .disabledColor {
    color: #c5c8ce;
  }
}
.light {
  color: #515a6e;
  box-shadow: 0rem 0rem 0.64rem rgba(0, 0, 0, 0.2);
  background: #fff;
  &.top {
    margin-top: -0.426667rem;
  }
  &.top::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    border-width: 0.426667rem 0.426667rem 0;
    border-style: solid;
    border-color: #ffffff transparent transparent;
  }
  &.right {
    margin-right: -0.426667rem;
  }
  &.right::after {
    content: '';
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-width: 0.426667rem 0.426667rem 0.426667rem 0;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
  }
  &.bottom {
    margin-bottom: -0.426667rem;
  }
  &.bottom::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translateX(-50%);
    border-width: 0 0.426667rem 0.426667rem;
    border-style: solid;
    border-color: transparent transparent #fff;
  }
  &.left {
    margin-left: -0.426667rem;
  }
  &.left::after {
    content: '';
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-width: 0.426667rem 0 0.426667rem 0.426667rem;
    border-style: solid;
    border-color: transparent transparent transparent #fff;
  }
  .disabledColor {
    color: #c5c8ce;
  }
}
.solid-bottom {
  border-bottom: 0.021333rem solid #ccc;
}
.solid-right {
  border-right: 0.021333rem solid #ccc;
}
.popups .itemChild:last-child {
  border: none;
}
</style>
